import { DestroyRef, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { Store } from '@ngrx/store';

import { AccountSelectors } from '@recruitee/account-data';
import { filterBoolean } from '@recruitee/common';
import type { Company } from '@recruitee/company-types';
import { GdprConfigurationSelectors } from '@recruitee/gdpr-data';
import type { GdprConfiguration } from '@recruitee/gdpr-types';
import { GdprRequestKind } from '@recruitee/gdpr-types';

@Injectable({ providedIn: 'root' })
export class RedactorInsetsGdprService {
  private currentCompany: Company;
  private gdprConfiguration: GdprConfiguration;
  constructor(
    private store: Store,
    private destroyRef: DestroyRef,
  ) {
    this.store
      .select(AccountSelectors.currentCompany)
      .pipe(filterBoolean, takeUntilDestroyed(this.destroyRef))
      .subscribe(currentCompany => (this.currentCompany = currentCompany));

    this.store
      .select(GdprConfigurationSelectors.data)
      .pipe(filterBoolean, takeUntilDestroyed(this.destroyRef))
      .subscribe(gdprConfiguration => {
        this.gdprConfiguration = gdprConfiguration;
      });
  }

  public createLink(requestKind?: GdprRequestKind): string {
    const host = this.currentCompany.host;
    return `https://${host}/v/gdpr/consent/${this.gdprConfiguration.expirationDays}/no-token`;
  }
}
